// #region imports

// --- Angular
import { Component } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent {

  constructor() { }

}
